import { render, staticRenderFns } from "./ChildList.vue?vue&type=template&id=2fd23768&scoped=true&"
import script from "./ChildList.vue?vue&type=script&lang=js&"
export * from "./ChildList.vue?vue&type=script&lang=js&"
import style0 from "./ChildList.vue?vue&type=style&index=0&id=2fd23768&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd23768",
  null
  
)

export default component.exports